import React from "react";
import SVGIcon, { IconProps } from "ui/SVGIcon";

const path =
  "M6 10.9257C4.9 10.9257 4 11.8257 4 12.9257C4 14.0257 4.9 14.9257 6 14.9257C7.1 14.9257 8 14.0257 8 12.9257C8 11.8257 7.1 10.9257 6 10.9257ZM18 10.9257C16.9 10.9257 16 11.8257 16 12.9257C16 14.0257 16.9 14.9257 18 14.9257C19.1 14.9257 20 14.0257 20 12.9257C20 11.8257 19.1 10.9257 18 10.9257ZM10 12.9257C10 11.8257 10.9 10.9257 12 10.9257C13.1 10.9257 14 11.8257 14 12.9257C14 14.0257 13.1 14.9257 12 14.9257C10.9 14.9257 10 14.0257 10 12.9257Z";

export default function Ellipsis(props: IconProps) {
  return <SVGIcon path={path} {...props} />;
}
